export default __webpack_public_path__ + "static/media/facebook.aa1ebee8.svg";